import { useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import StateButton from "../../components/state-button/StateButton";
import "./ProductPage.scss";
import BannerImg from "../../assets/images/updated_Product-BannerImg-new.png";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import badge from "../../assets/images/Badge.svg";
import badge2 from "../../assets/images/Badge2.svg";
import FeaturesImg from "../../assets/images/FeaturesImg-new.png";
import iPhoneimg from "../../assets/images/updated_iPhone-15-Pro.png";
import {NotificationManager} from 'react-notifications';
import ContactForm from "../../components/ContactForm/ContactForm";

import { getFeaturesByProductId, getServicesByProductId, getMailProductCountry, getMailProductCity, getMailProductCitiesByCountry, getPageContent, submitInquiry } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import { Tag } from "../../utils/GTMPageTag";

const ProductPage = () => {
  Tag("Geschäftsadresse")
  const {hostLanguage} = useLangContext();

  const [contentDetails,setContentDetails] = useState();
  const [features,setFeatures] = useState([]);
  const [cities,setCities] = useState([]);
  const [countries,setCountries] = useState([]);
  const [services,setServices] = useState([]);

  const contactRef = useRef(null);
  const [selectedCities,setSelectedCities] = useState([]);

  // get page content
  const getAllPageContent = async() => {
    try
    {
      let apiRes = await  getPageContent(hostLanguage, "product_mail_page_data");
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setContentDetails(responseData.data);
        // console.warn(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }
  // fetch features
  const fetchProductFeatures = async(product_id) => {
    try
    {
      let apiRes = await getFeaturesByProductId(product_id);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setFeatures(responseData.data)
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }
  // fetch all mail product cities
  const fetchMailProductCity = async(product_id) => {
    try
    {
      let apiRes = await getMailProductCity(product_id);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setCities(Object.values(responseData.data).flat());
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }
  // fetch all mail product countries
  const fetchMailProductCountry = async(product_id) => {
    try
    {
      let apiRes = await getMailProductCountry(product_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setCountries(Object.values(responseData.data).flat());
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }
  // fetch all mail product services
  const fetchProductServices = async (product_id) => {
    try
    {
      let apiRes = await getServicesByProductId(product_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setServices(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }




  const sendInquiry = async (values, { resetForm }) => {
    try {
      let data_values = {
        companyname: values.companyname,
        name: values.name,
        email: values.email,
        phonenumber: values.phonenumber,
        message: values.message,
      };

      let apiRes = await submitInquiry(data_values);
      let responseData = await apiRes.json();
      if (responseData.res) {
        resetForm({ values: "" });
        NotificationManager.success(responseData.msg, "", 2000);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  
  //Get All Mail Product City
  const handleSelectedCities = async(country_id) => {
    try
    {
      let apiRes = await getMailProductCitiesByCountry(country_id,hostLanguage);
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setSelectedCities(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }

  // get banner image link
  const getBannerImgLink = (img_link) => {
    try
    {
      let base_url = 'https://cleverdomizil.de';
      let url = base_url + img_link?.split("httpdocs")[1];
      return url
    }
    catch(error)
    {
      console.error(error);
    }
  }

  const handleTabSelect = (key) => {
    const selectedCountryId = countries.find((item) => item?.country?.name === key);
    handleSelectedCities(selectedCountryId?.country?.id);
  }

  const appLink = (type) =>{
    if(type === 'android')
    {
      window.open('https://play.google.com/store/apps/details?id=com.cleverdomizilmail')
    }
    else if(type === 'apple')
    {
      window.open('https://apps.apple.com/in/app/cleverdomicile/id6502281781')
    }
  }

  useEffect(()=>{
    getAllPageContent();
    fetchProductFeatures(1);
    fetchMailProductCity(1);
    fetchMailProductCountry(1);
    fetchProductServices(1);
  },[hostLanguage])

  return (
    <>
      <div id="ProductMailbox" className="MainbBody">
        <div className="InnerBannerScetion">
          <div className="InnerBannerScetionLft">
            <div dangerouslySetInnerHTML={{ __html: contentDetails?.product_mail_page_data?.banner_text}}></div>
            <div className="BtnGrp">
              <Link className="BtnGrpLoc" to ='/standorte'>{contentDetails?.product_mail_page_data?.banner_button_1}</Link>
              <StateButton 
                className="BtnGrpBN" text={contentDetails?.product_mail_page_data?.banner_button_2}
                to={"/preise/geschaeftsadresse"}
                userTo='/LetStarted'
              />
              </div>
          </div>

          <div className="InnerBannerScetionRgt">
            <Image
              src={BannerImg}
              className="BannerImg"
              alt="BannerImg"
              fluid
            />
          </div>
        </div>
        <div className="FourBoxScetion">
          <Container>
            <Row>
              {features?.map((item,index)=>{
                return(
                  <Col sm={6} md={3} key={index}>
                  <div className="FourBoxScetionBox">
                    <span>
                      {" "}
                      <Image
                        src={getBannerImgLink(item?.feature_image)}
                        className="BannerImg"
                        alt="BannerImg"
                        fluid
                      />
                    </span>
                    <h3>{item?.feature_name}</h3>
                    <div dangerouslySetInnerHTML={{ __html: item?.description}} />
                  </div>
                  </Col>
                )
              })}
            </Row>
          </Container>
        </div>
        <div className="LocationsScetion">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel" dangerouslySetInnerHTML={{__html: contentDetails?.product_mail_page_data?.country_heading}}></div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col sm={12}>
                <Tabs
                  defaultActiveKey="all"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                  onSelect={handleTabSelect}
                >
                  <Tab eventKey="all" title={contentDetails?.product_mail_page_data?.country_list_first_text ?? "TAB"}>
                    <div className="LocationName">
                      <ul>
                        {cities?.map((item,index)=>{
                            return(
                              <li key={index}>
                                <div className="LocationNameBox">
                                  <Link to={'/geschaeftsadresse/'+item?.city?.key}>
                                    <h4>{item?.city?.name?.toUpperCase()}</h4>
                                  </Link>
                                </div>
                              </li>
                            )
                          })}
                      </ul>
                    </div>
                  </Tab>
                  
                  {countries?.map((item, index) => (
                    <Tab
                      key={item?.country?.id}
                      eventKey={item?.country?.name}
                      title={item?.country?.name}
                    >
                      <div className="LocationName">
                        <ul>
                          {selectedCities?.map((city_item, city_index) => {
                            return(
                              <li key={city_index}>
                                <div className="LocationNameBox">
                                    <Link to={'/geschaeftsadresse/'+city_item?.city?.key}>
                                    <h4>{city_item?.city?.name?.toUpperCase()}</h4>
                                  </Link>
                                </div>
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="FeaturesScetion">
          <Container fluid>
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{contentDetails?.product_mail_page_data?.CleverDomizil_Postfach}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12} lg={6}>
                <div className="FeaturesScetionLft">
                  <Image
                    src={FeaturesImg}
                    className="FeaturesImg w-100"
                    alt="FeaturesImg"
                  />
                </div>
              </Col>

              <Col sm={12} lg={6}>
                <div className="FeaturesScetionRgt">
                  <div dangerouslySetInnerHTML={{__html: contentDetails?.product_mail_page_data?.CleverDomizil_Postfach_description}}></div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="AppScetion">
          <Container>
            <Row className="align-items-center">
              <Col sm={6}>
                <Image
                  src={iPhoneimg}
                  className="laptopbig"
                  alt="LaptopBig"
                  fluid
                />
              </Col>
              <Col sm={6}>
                <div className="AppScetionTxt">
                  <div dangerouslySetInnerHTML={{__html: contentDetails?.product_mail_page_data?.CleverDomizil_APP}}></div>
                  <div className="ImgGrp">
                    <span className="ImgGrpImg">
                      <img src={badge} alt="badge" onClick={()=>appLink('android')} style={{cursor:'pointer'}}/>
                    </span>
                    <span className="ImgGrpImg">
                      <img src={badge2} alt="badge" onClick={()=>appLink('apple')} style={{cursor:'pointer'}}/>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="PlanScetion">
          <Container className="">
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>CleverDomizil Postfach</h2>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col sm={12}>
                <div className="PlanComparisonDiv">
                  <table>
                    <tbody>
                      <tr>
                        <th>&nbsp;</th>
                        <th>
                          <div dangerouslySetInnerHTML={{__html: contentDetails?.product_mail_page_data?.tarife_element_1}}></div>
                        </th>
                        <th>
                          <div dangerouslySetInnerHTML={{__html: contentDetails?.product_mail_page_data?.tarife_element_2}}></div>
                        </th>
                      </tr>
                      {services?.map((item,index)=>{
                        return(
                          <tr key={index}>
                            <td>{item?.service_name}</td>
                            <td>
                              {item?.private_status === 1 && (
                                <Image
                                  src={"/images/feature-included.svg"}
                                  className="TickImg"
                                  alt="TickImg"
                                />
                              )}
                                <br />
                                {item?.additional_private_status!= null ? item?.additional_private_status: ''}
                            </td>

                            <td>
                              {item?.business_status === 1 && (
                                <Image
                                  src={"/images/feature-included.svg"}
                                  className="TickImg"
                                  alt="TickImg"
                                />
                              )}
                              <br />
                              {item?.additional_business_status!= null ? item?.additional_business_status: ''}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div ref={contactRef} className="ContactFrmScetion">
          <Container>
            <Row className="align-items-center justify-content-center">
              <div className="ScetionTitel">
                <h2>{contentDetails?.product_mail_page_data?.contact_heading}</h2>
              </div>
              <Col sm={8}>
                {contentDetails && (
                  <ContactForm
                    contentDetails={contentDetails}
                    hostLanguage={hostLanguage}
                    onSubmit={sendInquiry}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default ProductPage;
